import React, { PureComponent } from 'react';
import './style.scss';
import Table from '../../../../../components/table';
import { connect } from 'react-redux';
import { ACTIONS, getTeam1, convertBatterPitcherUse, convertListBatter } from './../../../../../actions/team-1';

class Pitcher extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            listPitcherTeamReport : [],
            listTop3Pitcher: []
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        const id = this.props.id;
        this.props.getTeam1(id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_1_SUCCESS) {
                this.setState({
                    listPitcherTeamReport : nextProps.response.top3_pitchers && convertBatterPitcherUse(nextProps.response.top3_pitchers[0].players, nextProps.id),
                    listTop3Pitcher: convertListBatter(nextProps.response.top3_pitchers, nextProps.id)
                })
            }
        }
    }

    onRedirect(value) {
        this.props.history.push(`/player/${value.id}`);
    }

    render() {
        return (
            <div className="pitcher">
                <h3 className="pitcher-title">投手TOP3</h3>
                <div className="grid">
                {
                        this.state.listTop3Pitcher && this.state.listTop3Pitcher.map((value, index) => {
                            return (
                                <div className="pitcher-block" key={index}>
                                    <Table
                                        header={value.headerTable}
                                        showCheckbox={false}
                                        showSearch={false}
                                        itemOfPage={value.items}
                                        isShowOptionTable={false}
                                        titleTable={value.title}
                                        showPagination={false}
                                        onRowClick={this.onRedirect}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ teamPitcher }) => {
    return {
        headerERATable: teamPitcher.headerERATable,
        titleERATable: teamPitcher.titleERATable,
        mockDataERATable: teamPitcher.mockDataERATable,
        headerVictoryTable: teamPitcher.headerVictoryTable,
        titleVictoryTable: teamPitcher.titleVictoryTable,
        mockDataVictoryTable: teamPitcher.mockDataVictoryTable,
        headerStrikeoutTable: teamPitcher.headerStrikeoutTable,
        titleStrikeoutTable: teamPitcher.titleStrikeoutTable,
        mockDataStrikeoutTable: teamPitcher.mockDataStrikeoutTable,
        headerPitchingTable: teamPitcher.headerPitchingTable,
        titlePitchingTable: teamPitcher.titlePitchingTable,
        mockDataPitchingTable: teamPitcher.mockDataPitchingTable,
        response: teamPitcher.response,
        status: teamPitcher.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getTeam1: (id) => {
            dispatch(getTeam1(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Pitcher);
